/**
 * Check if user is registered to application
 * @param {("anpost_myaccount" | "anpost_clickandpost" | "anpost_directmail" | "anpost_onlineshop" | "anpost_mydeliveries")} [applicationCode="anpost_myaccount"] - The application code.
 * @returns {boolean} `true` if user is registered to application, `false` otherwise.
 */

function checkIfUserIsRegisteredToApp(applicationCode = 'anpost_myaccount') {
  const userProfile = JSON.parse(sessionStorage.getItem('userProfile'))
  if (!userProfile) return false
  return !!userProfile.applications.find(
    (app) => app.applicationCode === applicationCode
  )
}

export default checkIfUserIsRegisteredToApp
